// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"new-arrival-product-list_listContainer__kHliG","productCard":"new-arrival-product-list_productCard___Oxy9"};